 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		44: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		44: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"f28da6f9327380e5b2acdff4b1a086ed3fb101cc","1":"e3116920bb69d70375ee401a1f279b3340f2412f","2":"fd264c14ee0e01e22c2431ff04ee77d96f6785ad","3":"styles","4":"3fe84e1facf1919004c842e3d381168a140f41ef","5":"1579f0951790d57208a7686aafacdb19defeca4a","6":"757c3cef3e7920421593e3ba0b36360e51bafe2e","7":"4cbeafed16922d31e93a6f66face2f45451e241a","8":"ff22fa82691768f406a143c0e26325699fc855c2","12":"component---cache-caches-gatsby-plugin-offline-app-shell-js","13":"component---src-pages-404-js","14":"component---src-pages-about-js","15":"component---src-pages-account-email-js","16":"component---src-pages-account-index-js","17":"component---src-pages-account-name-js","18":"component---src-pages-account-password-js","19":"component---src-pages-ailments-js","20":"component---src-pages-app-js","21":"component---src-pages-blog-js","22":"component---src-pages-create-herb-review-index-js","23":"component---src-pages-create-herb-review-thank-you-js","24":"component---src-pages-disclaimer-js","25":"component---src-pages-download-app-js","26":"component---src-pages-faq-js","27":"component---src-pages-favorites-js","28":"component---src-pages-herbs-js","29":"component---src-pages-home-js","30":"component---src-pages-index-js","31":"component---src-pages-login-js","32":"component---src-pages-privacy-policy-js","33":"component---src-pages-register-js","34":"component---src-pages-search-js","35":"component---src-pages-symptom-checker-ailment-results-js","36":"component---src-pages-symptom-checker-index-js","37":"component---src-pages-symptom-checker-select-symptoms-js","38":"component---src-pages-user-agreement-js","39":"component---src-templates-ailment-js","40":"component---src-templates-article-js","41":"component---src-templates-herb-js","42":"component---src-templates-product-js"}[chunkId]||chunkId) + "-" + {"0":"c8456e3fff1ed857250e","1":"f18c8a83c41c28ed7a40","2":"65877e608be4263194f0","3":"ccfac98b72d746365bce","4":"a8ffe9b028fe21c1f382","5":"5e2a589a5e3ba2124701","6":"dbb926f952906eacc94b","7":"a6efac0c9795ae1bd5bd","8":"376ed0b7814fab368381","9":"3d72ceb778594558017f","10":"f5de90698e8ce667bf39","12":"a2ac4e90be868d25f3c3","13":"6b8fff17f33c15c96f04","14":"d9dab74873a8cfd794c1","15":"7f8a40eec042cfe50995","16":"f857bffc6cfd8580adf9","17":"947c3be1e49563e06155","18":"ea344808b7d62265b029","19":"e3e23a039f9f91edfc4a","20":"8ff9c8de2d57060d8ac3","21":"de8d566fd454785de0eb","22":"84b1c987e7e33547451f","23":"850b44bb2bbe48e61918","24":"68a1105c74f060c0fe57","25":"affe4c28eefb9c670e4b","26":"d61abca74126a2b4f330","27":"77e8940d571a418b0d90","28":"9a892eecc94681ddac12","29":"1d2106ec4811ef6e819b","30":"d979a29c73eceb1562a0","31":"74a48e7f2a44c65a85c5","32":"b1fb37a7c5176e42ea1c","33":"46132338d1acf0ae3ba3","34":"3f8c369c8ef44f9b2197","35":"421e46e4f31e84882a00","36":"46a90d3d106f47dfa26f","37":"da90cd74b4b5aa3c49b6","38":"de32e73f0cbbf78dc2a2","39":"2a02a4cf1a4ceccba35f","40":"3403948e4b61c176bd8a","41":"b33e40eb56f2deddf732","42":"407ff9da3ee9ed1f35a2","45":"0f7c9190c2d6bdfaaa07"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"f28da6f9327380e5b2acdff4b1a086ed3fb101cc","1":"e3116920bb69d70375ee401a1f279b3340f2412f","2":"fd264c14ee0e01e22c2431ff04ee77d96f6785ad","3":"styles","4":"3fe84e1facf1919004c842e3d381168a140f41ef","5":"1579f0951790d57208a7686aafacdb19defeca4a","6":"757c3cef3e7920421593e3ba0b36360e51bafe2e","7":"4cbeafed16922d31e93a6f66face2f45451e241a","8":"ff22fa82691768f406a143c0e26325699fc855c2","12":"component---cache-caches-gatsby-plugin-offline-app-shell-js","13":"component---src-pages-404-js","14":"component---src-pages-about-js","15":"component---src-pages-account-email-js","16":"component---src-pages-account-index-js","17":"component---src-pages-account-name-js","18":"component---src-pages-account-password-js","19":"component---src-pages-ailments-js","20":"component---src-pages-app-js","21":"component---src-pages-blog-js","22":"component---src-pages-create-herb-review-index-js","23":"component---src-pages-create-herb-review-thank-you-js","24":"component---src-pages-disclaimer-js","25":"component---src-pages-download-app-js","26":"component---src-pages-faq-js","27":"component---src-pages-favorites-js","28":"component---src-pages-herbs-js","29":"component---src-pages-home-js","30":"component---src-pages-index-js","31":"component---src-pages-login-js","32":"component---src-pages-privacy-policy-js","33":"component---src-pages-register-js","34":"component---src-pages-search-js","35":"component---src-pages-symptom-checker-ailment-results-js","36":"component---src-pages-symptom-checker-index-js","37":"component---src-pages-symptom-checker-select-symptoms-js","38":"component---src-pages-user-agreement-js","39":"component---src-templates-ailment-js","40":"component---src-templates-article-js","41":"component---src-templates-herb-js","42":"component---src-templates-product-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"656c27b28502f5aeabed","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
